module.exports = __webpack_public_path__ + "static/media/fa-regular-400.63a58350.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-regular-400.woff2
// module id = 769
// module chunks = 0